<template>
  <div class="home">
    <Header />
    <Navigation />
    <div class="banner">
      Advanced Psoriasis Treatment & Research
    </div>
    <div class="content-container">
      <AboutSection />
      <ServicesSection />
      <ResearchSection />
      <TestimonialsSection />
      <ContactSection />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Navigation from '@/components/Navigation.vue'
import AboutSection from '@/components/AboutSection.vue'
import ServicesSection from '@/components/ServicesSection.vue'
import ResearchSection from '@/components/ResearchSection.vue'
import TestimonialsSection from '@/components/TestimonialsSection.vue'
import ContactSection from '@/components/ContactSection.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'HomeView',
  components: {
    Header,
    Navigation,
    AboutSection,
    ServicesSection,
    ResearchSection,
    TestimonialsSection,
    ContactSection,
    Footer
  }
}
</script>

<style scoped>
.home {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.banner {
  background-color: #42b983;
  color: white;
  padding: 40px 20px;
  text-align: center;
  font-size: 2em;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.content-container {
  flex: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

@media (max-width: 768px) {
  .banner {
    font-size: 1.5em;
    padding: 30px 15px;
  }
}
</style>
